import { authHeader, ApiConfigs } from '../_helpers'

export const payment = {
  getPaymentWithChecks,
  viewChecks,
  filterPayments, 
  destroyPayment, 
  updateNumFac,
  getPaymentWithChecksClient,
  viewChecksClient,
  filterPaymentsClient

}

async function getPaymentWithChecks() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const getUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.getPaymentWithChecks}`;

  return await fetch(getUrl, requestOptions).then(handleResponse);
}
async function viewChecks(paymentId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const getUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.viewChecks.replace('{payment}', paymentId)}`;

  return await fetch(getUrl, requestOptions).then(handleResponse);
}
async function filterPayments(Filters) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(Filters),
  };
  const postUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.filterPayments}`;

  return await fetch(postUrl, requestOptions).then(handleResponse);
}
async function destroyPayment(paymentId) {
  const requestOptions = {
      method: 'GET',
      headers: authHeader(),
  };
  const deleteUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.destroyPayment.replace('{payment}', paymentId)}`;
  return await fetch(deleteUrl, requestOptions).then(handleResponse);
}
async function updateNumFac(paymentId, newNumeroDeFacture) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ numero_de_facture: newNumeroDeFacture }),
  };
  const putUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.updateNumFac.replace('{id}', paymentId)}`;

  return await fetch(putUrl, requestOptions).then(handleResponse);
}

async function getPaymentWithChecksClient() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const getUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.getPaymentWithChecksClient}`;

  return await fetch(getUrl, requestOptions).then(handleResponse);
}

async function viewChecksClient(paymentId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
  };
  const getUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.viewChecksClient.replace('{payment}', paymentId)}`;

  return await fetch(getUrl, requestOptions).then(handleResponse);
}

async function filterPaymentsClient(Filters) {
  const requestOptions = {
    method: 'POST',
    headers: {
      ...authHeader(),
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(Filters),
  };
  const postUrl = `${ApiConfigs.base_url}${ApiConfigs.payment.filterPaymentsClient}`;

  return await fetch(postUrl, requestOptions).then(handleResponse);
}
async function handleResponse(response) {
  return response.text().then(text => {
    text = text.slice(text.indexOf('{'), text.lastIndexOf('}') + 1);
    const data = text && JSON.parse(text)
    if (!response.ok) {
      if (response.status === 401) {
        localStorage.removeItem("profile"); 
        localStorage.removeItem("token"); 
        window.location.href = '/login'
      }
      if (response.status === 404) {
        return null
      }

      const error = (data && data.message) || response.statusText
      return Promise.reject(error)
    }

    return data
  })
}
